import React, { useState } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import DialogContent from '@material-ui/core/DialogContent';
import DeleteIcon from '@material-ui/icons/Delete';
import StadiumButton from '../../../../../customComponents/button/StadiumButton';
import DialogActions from '@material-ui/core/DialogActions';
import OutlinedStadiumButton from '../../../../../customComponents/button/OutlinedStadiumButton';
import AppFunctionsService from '../../../../../../services/appFunctionsService';
import { ITransformerPrepaidReading } from '../../../../../../@types/model/transformer/reading/transformerPrepaidReading';
import ProjectDialog from '../../../../../customComponentV2/dialog/ProjectDialog';

interface ITransformerPrepaidReadingDeleteDialogProps {
    reading : ITransformerPrepaidReading;
    onDelete : (reading : ITransformerPrepaidReading) => void;
}

const TransformerPrepaidReadingDeleteDialog = (props : ITransformerPrepaidReadingDeleteDialogProps) : React.ReactElement => {
    const [open, setOpen] = useState<boolean>(false);

    const onClick = () : void => {
        setOpen(true);
    };

    const onClose = () : void => {
        setOpen(false);
    };

    const onDeleteClick = async () : Promise<void> => {  
        if (props.onDelete) props.onDelete(props.reading);      
        onClose();
    };

    return (
        <div>
            <Tooltip title='Delete'>
                <div>
                    <IconButton className={'cr'} onClick={onClick}
                        aria-label='Delete'>
                        <DeleteIcon />
                    </IconButton>
                </div>
            </Tooltip>
            <ProjectDialog
                isOpen={open}
                onClose={onClose}
                maxWidth={'md'}
                fullWidth
                headerColour={'red'}
                title={`REMOVE READING | ${AppFunctionsService.formatDateTimeToDateOnly(props.reading.date)} | ${props.reading.transformerRef}`}
            >
                <DialogContent className='fdc flx1 ais hfill bcg0'>
                    <div className='fdc flx1 ais jcc'>
                        <p>
                            Remove Reading?
                        </p>
                    </div>
                </DialogContent>
                <DialogActions className='bcg0'>
                    <OutlinedStadiumButton className='mr16' variant='text' onClick={onClose}>
                        CANCEL
                    </OutlinedStadiumButton>
                    <StadiumButton variant='contained' onClick={onDeleteClick}>
                        REMOVE
                    </StadiumButton>
                </DialogActions>
            </ProjectDialog>
        </div>
    );
};

export default TransformerPrepaidReadingDeleteDialog;
